import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

// Disable auto CSS import into head.
// Recommended in https://github.com/FortAwesome/ember-fontawesome/blob/3.x/README.md#using-in-projects-with-template-tag-gjs--gts---recommended
config.autoAddCss = false;
